import React, {
    useReducer,
    useState,
    useCallback,
    useEffect,
    useMemo,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

// component
import Header from '../../controls/Header'
import ExportExcel from '../../controls/Tools/ExportExcel'

import SelectTrans from '../../controls/Tools/SelectTrans'
import SelectServicesRating from '../../controls/Tools/SelectServicesRating'
import ButtonFilter from '../../controls/Tools/ButtonFilter'
import Table from '../../controls/Table'
import SelectStartDate from '../../controls/Tools/SelectStartDate'
import SelectEndDate from '../../controls/Tools/SelectEndDate'
import SelectOfficeV2 from '../../controls/Tools/SelectOfficeV2'

// styles
import { extendStylesTable, extendStylesOffice } from './index.styles'
import {
    WrapGridTools,
    GridColTools,
    GridSplitHeadTools,
    GridBtnToolsEnd,
    WrapGridToolsCustom,
} from '../../controls/Tools/index.styles'

// action
import {
    getListServicesRatingByServices,
    exportListServicesRatingByServices,
} from '../../../../../../../actions/reportsAction/detailsReport/servicesRating/serviceRating'

// hooks
import useDidMount from '../../../../../../../helper/Hooks/useDidMount'

// constant
import { ADMIN_ROLE } from '../../../../../../../data/userRole'

const lstTitleCols = ['Mã cn', 'Tên cn', 'loại giao dịch', 'kết quả đánh giá', 'Số lượng GD']

const lstTrans = [
    {
        key: 'DEPINT',
        value: 'Nộp tiền trong VietinBank',
    },
    {
        key: 'DEPEXT',
        value: 'Nộp tiền ngoài VietinBank',
    },
    {
        key: 'WITHDRAW',
        value: 'Rút tiền',
    },
    {
        key: 'TRANSINT',
        value: 'Chuyển khoản trong VietinBank',
    },
    {
        key: 'TRANSEXT',
        value: 'Chuyển khoản ngoài VietinBank thông thường',
    },
    {
        key: 'TRANSEXTACC',
        value: 'Chuyển khoản nhanh ngoài VietinBank đến số tài khoản (≤300trđ)',
    },
    {
        key: 'TRANSEXTCARD',
        value: 'Chuyển khoản nhanh ngoài VietinBank đến số thẻ (≤300trđ)',
    },
    {
        key: 'SAVINGDEP',
        value: 'Gửi tiết kiệm',
    },
    {
        key: 'WDSVG',
        value: 'Rút tiết kiệm',
    },
    {
        key: 'FCY',
        value: 'Ngoại tệ',
    },
    {
        key: 'CARD',
        value: 'Thẻ',
    },
    {
        key: 'CORPCUST',
        value: 'Khách hàng doanh nghiệp',
    },
    {
        key: 'OTHER',
        value: 'Khác',
    },
    {
        key: 'DIRECTCALL',
        value: 'Trống (Vé load CIF)',
    },
]

// const DEFAULT_FROM_DATE = moment().startOf('days')
// const DEFAULT_TO_DATE = moment().endOf('days')

const ReportByService = ({ title, codeName, ...props }) => {
    const DEFAULT_FROM_DATE = useMemo(() => moment().startOf('days'), [])
    const DEFAULT_TO_DATE = useMemo(() => moment().endOf('days'), [])

    const dispatch = useDispatch()
    const { detailsReport, userReducer } = useSelector((state) => ({
        detailsReport: state.reports.detailsReport,
        userReducer: state.userReducer,
    }))

    const [stateFilter, dispatchFilter] = useReducer(
        (state, action) => ({ ...state, ...action }),
        {
            fromDate: DEFAULT_FROM_DATE.toDate(),
            toDate: DEFAULT_TO_DATE.toDate(),
            office: null,
            transaction: null,
            service: null,
        }
    )

    const [dataTable, setDataTable] = useState([])

    const [BranchIDs, BranchName, BranchCodes] = useMemo(() => {
        if (!stateFilter.office) return [null, null, null]
        const lenListOffice = stateFilter.office.length
        if (lenListOffice === 0) {
            return [null, null, null]
        }
        if (lenListOffice === 1) {
            const { key, value, BranchCode } = stateFilter.office[0]
            if (Array.isArray(key))
                return [key, value, BranchCode ? [BranchCode] : ['ALL']]
            return [[key], value, BranchCode ? [BranchCode] : ['ALL']]
        }

        const lstBranchId = [],
            lstBranchName = [],
            lstBranchCode = []

        const lstOfficeSort = [...stateFilter.office].sort((a, b) => 
            Number(a.BranchCode) - Number(b.BranchCode)
        )

        lstOfficeSort.forEach((element) => {
            lstBranchId.push(element.key)
            lstBranchName.push(element.value)
            lstBranchCode.push(element.BranchCode)
        })
        return [lstBranchId, lstBranchName.join(', '), lstBranchCode]
    }, [stateFilter.office])

    const _handleSubmit = useCallback(() => {
        const { fromDate, toDate, transaction, service, office } = stateFilter
        dispatch(
            getListServicesRatingByServices({
                FromDate: fromDate.toISOString(),
                ToDate: toDate.toISOString(),
                Rating: service?.key,
                ServiceCode: transaction?.key,
                ReportCodeName: codeName,
                BranchName,
                BranchIDs,
            })
        )
    }, [stateFilter, BranchName, BranchIDs])

    const _handleExportExcel = useCallback(() => {
        const { fromDate, toDate, service, transaction, office } = stateFilter
        dispatch(
            exportListServicesRatingByServices({
                FromDate: fromDate.toISOString(),
                ToDate: toDate.toISOString(),
                Rating: service?.key,
                ServiceCode: transaction?.key,
                ReportCodeName: codeName,
                BranchName,
                BranchIDs,
                BranchCodes,
            })
        )
    }, [stateFilter, BranchName, BranchIDs, BranchCodes])

    useDidMount(() => {
        if (!userReducer.dataLogin) return false
        const { Roles } = userReducer.dataLogin
        if (Roles.includes(ADMIN_ROLE)) return true

        if (!BranchName || !BranchIDs) return false
        dispatch(
            getListServicesRatingByServices({
                FromDate: DEFAULT_FROM_DATE.toISOString(),
                ToDate: DEFAULT_TO_DATE.toISOString(),
                ReportCodeName: codeName,
                BranchName,
                BranchIDs,
            })
        )
        return true
    }, [userReducer.dataLogin, BranchName, BranchIDs])

    useEffect(() => {
        // const dataTable = detailsReport.listData.map(item => [
        //     item.Service,
        //     item.Rating,
        //     item.Total,
        // ])
        setDataTable(detailsReport.listData)
    }, [detailsReport.listData])

    return (
        <div>
            <Header title={title} />
            {/* <Tools> */}
            <WrapGridToolsCustom templateCol="auto 1fr 1fr" gap="140px">
                <GridColTools>
                    <SelectOfficeV2
                        defaultValue={stateFilter.office}
                        onChange={(office) => dispatchFilter({ office })}
                        extendStyles={extendStylesOffice}
                    />
                    <SelectServicesRating
                        defaultValue={stateFilter.service}
                        onChange={(service) => dispatchFilter({ service })}
                    />
                </GridColTools>
                <GridSplitHeadTools template={['auto 1fr 1fr 1fr', 'auto 1fr']}>
                    <div>
                        <SelectStartDate
                            defaultValue={stateFilter.fromDate}
                            onChange={(fromDate) =>
                                dispatchFilter({ fromDate })
                            }
                        />
                        <SelectEndDate
                            defaultValue={stateFilter.toDate}
                            onChange={(toDate) => dispatchFilter({ toDate })}
                        />
                    </div>
                    <div>
                        <SelectTrans
                            defaultValue={stateFilter.transaction}
                            onChange={(transaction) =>
                                dispatchFilter({ transaction })
                            }
                            lstTrans={lstTrans}
                        />
                    </div>
                </GridSplitHeadTools>
                <GridBtnToolsEnd>
                    <ButtonFilter
                        data={stateFilter}
                        onClick={_handleSubmit}
                        isDisable={!BranchIDs}
                    />
                    <ExportExcel
                        onClick={_handleExportExcel}
                        isDisable={!BranchIDs}
                    />
                </GridBtnToolsEnd>
            </WrapGridToolsCustom>
            {/* </Tools> */}
            <Table
                lstTitleCols={lstTitleCols}
                lstData={dataTable}
                extendStyles={extendStylesTable}
            />
        </div>
    )
}

export default ReportByService
